// extracted by mini-css-extract-plugin
export var menuIcon = "_n6-0";
export var menuIconInline = "_n6-1";